import React from 'react'
import {
  NextVideo,
  NextVideoSectionContainer,
  RenderedVideoSectionContainer,
  VidWrapper,
} from '../style'

//* images
import DefaultGrid from '../../../../../static/steam-img/no-image-grid.svg'
import videoButtonPlayNormal from '../../../../../static/steam-img/video-button-play-normal.svg'

//* utils
import { ModuleNames } from '../../../../constants/componentNames.constants'
import ImgUtil from '../../../../utils/img.utils'
import { correctSlugPrefix, isExternalURL } from '../../../../utils/link.utils'
import { renderRichText } from '../../../../utils/richTextHandler.utils'
import formatInlineCode from '../../../../utils/shortTextFormatting'

//* components
import GlobalContainer from '../../globalContainer'
import Typography from '../../typography'
import VideoPlayer from '../../videoPlayer'
import WrapperImage from '../../wrapperImage'
import { renderCTA, renderHeadline } from './spotlight'

export const renderVideoSection = (
  videoSpotlightData: any,
  isFeaturedVideo: any,
  isHorizontal: boolean
) => {
  return (
    <>
      <VidWrapper
        className={videoSpotlightData.useCase === 'Full width' ? 'VideoSpotlight__Full-Width' : ''}>
        <VideoPlayer
          width={'100%'}
          height="429"
          videoId={videoSpotlightData.video.id}
          videoUrl={videoSpotlightData.video.url}
          type={videoSpotlightData.video.type}
          img={videoSpotlightData.video.image}
          backgroundAltText={videoSpotlightData.video.altText}
          backgroundImgParams={'width=732'}
          start={videoSpotlightData.video.start}
          animationFileUrl={videoSpotlightData.video.animationFile}
        />
      </VidWrapper>

      {(videoSpotlightData.cta || videoSpotlightData.body) && !isHorizontal && (
        <div className="VideoSpotlight__Content-Container">
          {videoSpotlightData.body && (
            <div className="VideoSpotlight__Body font__inter">
              {renderRichText(videoSpotlightData.body)}
            </div>
          )}

          <div className="FeaturedVideo_headline_CTA_container">
            {videoSpotlightData.cta && renderCTA(videoSpotlightData, isFeaturedVideo)}
          </div>
        </div>
      )}
    </>
  )
}

export const renderFeaturedVideoSection = (
  videoSpotlightData: any,
  isFeaturedVideo: any,
  isHorizontal: boolean
) => {
  return (
    <GlobalContainer className="FeaturedVideos__bottom_container">
      <RenderedVideoSectionContainer>
        <VidWrapper className="FeaturedVideos__MainVideoWrapper">
          <VideoPlayer
            width={'100%'}
            height="429"
            videoId={videoSpotlightData.video.id}
            type={videoSpotlightData.video.type}
            videoUrl={videoSpotlightData.video.url}
            img={videoSpotlightData.video.image}
            backgroundAltText={videoSpotlightData.video.altText}
            backgroundImgParams={'width=732'}
            start={videoSpotlightData.video.start}
            animationFileUrl={videoSpotlightData.video.animationFile}
          />

          {(videoSpotlightData.cta || videoSpotlightData.headline) && (
            <div className="VideoSpotlight__Content-Container">
              <div className="FeaturedVideo_headline_CTA_container">
                {videoSpotlightData.headline &&
                  renderHeadline(videoSpotlightData, isFeaturedVideo, isHorizontal)}
                {videoSpotlightData.cta && renderCTA(videoSpotlightData, isFeaturedVideo)}
              </div>
            </div>
          )}
        </VidWrapper>

        {videoSpotlightData.nextVideo.length > 0 && (
          <NextVideoSectionContainer>
            {videoSpotlightData.nextVideoTitle && (
              <Typography className="FeaturedVideos__nextVideoTitle" type="captionAlt">
                {videoSpotlightData.nextVideoTitle}
              </Typography>
            )}

            {videoSpotlightData.nextVideo.map((video: any, index: number) => {
              if (!video) return null

              const image = {
                url: video.slug || '',
                altText: '',
                teaserText: '',
              }

              switch (video.__typename) {
                case ModuleNames.PAGE_RESOURCE_DEMO:
                  image.url = video.spotlight?.video?.image?.file?.url || ''
                  image.altText = video.spotlight?.video?.altText || ''
                  image.teaserText = video.teaserBody || video.seoMetadata?.pageMetaDescription
                  break
                case ModuleNames.PAGE_PLACEHOLDER:
                  image.url = video.mainImage?.image?.file?.url || ''
                  image.altText = video.mainImage?.altText || ''
                  image.teaserText = video.teaserBody || video.seoMetadata?.pageMetaDescription
                  break
                case ModuleNames.PAGE_WEBINAR_RECORDING:
                  image.url = video.spotlight?.video?.image?.file?.url || ''
                  image.altText = video.spotlight?.video?.altText || ''
                  image.teaserText = video.teaserBody || video.seoMetadata?.pageMetaDescription
                  break
              }

              const imageOverlay = image ? true : false
              const linkTarget = isExternalURL(correctSlugPrefix(image.url)) ? '_blank' : '_self'

              return (
                <NextVideo $hasOverlay={imageOverlay} className="FeaturedVideos__Item" key={index}>
                  <a
                    href={correctSlugPrefix(image.url)}
                    target={linkTarget}
                    className="FeaturedVideos__Item-container-Link">
                    <div className="FeaturedVideos__Image-Container">
                      <WrapperImage
                        className="FeaturedVideos__Item-Icon"
                        src={videoButtonPlayNormal}
                        alt="Play button"
                        height={56}
                        width={56}
                        threshold={650}
                      />

                      <WrapperImage
                        className="FeaturedVideos__BackgroundImg"
                        src={
                          image ? ImgUtil.getResizedImageUrl(image.url, 'width=400') : DefaultGrid
                        }
                        height={400}
                        width={400}
                        alt={image.altText ? image.altText : 'Dotted Grid'}
                        threshold={650}
                      />
                    </div>

                    <div className="FeaturedVideos__Text-Container">
                      {image.teaserText && (
                        <Typography
                          className="FeaturedVideos__Item-teaserText font__inter"
                          type="bodyXS">
                          {formatInlineCode(image.teaserText)}
                        </Typography>
                      )}
                    </div>
                  </a>
                </NextVideo>
              )
            })}
          </NextVideoSectionContainer>
        )}
      </RenderedVideoSectionContainer>
    </GlobalContainer>
  )
}
